import { skipToken, useQuery } from '@apollo/client/react';

import { AppsDocument } from 'src/graphql/actions/apps/apps.query';

import type { ApplicationTab, SearchApplicationsQuery } from './types';

import { useApplications } from './ApplicationsContext';
import { isUnsatisfiableQuery } from './is-unsatisfiable-query';
import { toAppsQueryVariables } from './to-apps-query-variables';

function useTabCount(query: SearchApplicationsQuery, tab: ApplicationTab): number {
  const tabQuery = { ...query, tab };
  const isUnsatisfiable = isUnsatisfiableQuery(tabQuery);

  const { data, previousData } = useQuery(
    AppsDocument,
    isUnsatisfiable ? skipToken : { variables: { ...toAppsQueryVariables(tabQuery), perPage: 1 } },
  );

  if (isUnsatisfiable) return 0;

  return (data ?? previousData)?.apps.nodesCount ?? 0;
}

export function useApplicationTabCounts(): Record<ApplicationTab, number> {
  const { query } = useApplications();

  return {
    all: useTabCount(query, 'all'),
    unread_tasks: useTabCount(query, 'unread_tasks'),
    your_applications: useTabCount(query, 'your_applications'),
    vendor_applications: useTabCount(query, 'vendor_applications'),
    unclaimed: useTabCount(query, 'unclaimed'),
  };
}
